import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

const Signature = ({ data }) => {
  const completedOn = data["CompletedOn"] || {};
  const completedBy = data["CompletedBy"] || {};
  const companyName = data["CompanyName"] || {};

  return (
    <table className="signature border--none">
      <tbody>
        <tr>
          <td className="text--left" style={{ width: 140 }}>
            Dated at Singapore this
          </td>
          <td>{completedOn.fieldValue && moment(completedOn.fieldValue).format("MM DD YY")}</td>
          <td>{completedBy.fieldValue}</td>
          <td>{completedBy.fieldValue}</td>
          <td>{companyName.fieldValue}</td>
        </tr>
        <tr>
          <td />
          <td className="line" style={{ width: 140, verticalAlign: "top" }}>
            (mm dd yy)
          </td>
          <td className="line" style={{ verticalAlign: "top" }}>
            {"Employee's name"}
          </td>
          <td className="line">
            {"Employee's signature"}
            <br />
            (for self & dependants)
          </td>
          <td className="line">
            {"Company's Stamp & signature"}
            <br />
            of Employer (witness)
          </td>
        </tr>
      </tbody>
    </table>
  );
};

Signature.propTypes = {
  data: PropTypes.object,
};

export default Signature;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201706_NOCHILD/Signature.js